/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Usedefaultlocation2Inputs */

const en__field_usedefaultlocation2 = /** @type {(inputs: _Field_Usedefaultlocation2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use default location`)
};

/**
* | output |
* | --- |
* | "Use default location" |
*
* @param {_Field_Usedefaultlocation2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_usedefaultlocation2 = /** @type {((inputs?: _Field_Usedefaultlocation2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Usedefaultlocation2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_usedefaultlocation2(inputs)
});
export { _field_usedefaultlocation2 as "_field_useDefaultLocation" }